import { render, staticRenderFns } from "./Row.vue?vue&type=template&id=20d78a92&scoped=true&"
import script from "./Row.vue?vue&type=script&lang=js&"
export * from "./Row.vue?vue&type=script&lang=js&"
import style0 from "./Row.vue?vue&type=style&index=0&id=20d78a92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d78a92",
  null
  
)

export default component.exports